export const Icon = () => {
    return (
        <svg width="84" height="84" viewBox="0 0 84 84" fill="none" stroke="#D4BC87">
            <path
                d="M74.5284 42C74.5284 59.9649 59.9649 74.5284 42 74.5284C24.0351 74.5284 9.47159 59.9649 9.47159 42C9.47159 24.0351 24.0351 9.47159 42 9.47159C59.9649 9.47159 74.5284 24.0351 74.5284 42Z"
                strokeWidth="0.943181"
            />
            <path d="M42.2188 19.1094V42.0185L54.2188 55.1094" strokeWidth="0.943181" strokeLinecap="round" />
        </svg>
    );
};
